import { pluralize } from "@common/helpers/string";

/**
 * Suffix for a bulk action heading when some selected transactions are
 * excluded by a lock: ` (N transactions <reason> can't be changed)`. Empty
 * when nothing is locked, so callers can append it unconditionally.
 */
export function buildLockedSuffix({
    lockedCount,
    reason,
}: {
    lockedCount: number;
    reason: string;
}): string {
    if (lockedCount <= 0) {
        return "";
    }
    return ` (${lockedCount} ${pluralize("transaction", lockedCount)} ${reason} can't be changed)`;
}
